import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../theme/lexusTheme";

export const Wrapper = styled.div<SpaceProps>`
    padding: ${theme.space[4]}px ${theme.space[3]}px;
    background-color: ${theme.colors.silver};
    ${space}
`;

export const Inner = styled.div<SpaceProps>`
    ${space}
`;

export const Title = styled.div`
    margin-bottom: 16px;
    font-family: ${theme.fonts.bold};
    font-size: 2.2rem;
    line-height: 2.8rem;
`;

export const TitlePaymentSwitch = styled(Title)`
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.bold};
    font-size: 2.2rem;
    line-height: 2.8rem;
    color: ${theme.colors.midnight};
`;

export const DescriptionPaymentSwitch = styled.div`
    margin-bottom: ${theme.space[3]}px;
`;

export const CarDetails = styled.div`
    margin-bottom: 16px;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.midnight};

    li {
        list-style: none;
    }

    svg {
        color: ${theme.colors.azure};
    }
`;

export const PaymentDetailsWrapper = styled.div`
    margin-top: 32px;
    margin-bottom: 32px;
`;

export const DisclaimerWrapper = styled.div`
    font-size: 1.3rem;
    color: ${theme.colors.midnight};
`;
